import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

export default function PhoneInput({ value, onChange, placeholder, className = "" }) {
  const { t } = useTranslation();

  // Коды стран
  const countryCodes = [
    { code: '+49', country: 'germany', flag: '🇩🇪' },
    { code: '+7', country: 'russia', flag: '🇷🇺' },
    { code: '+380', country: 'ukraine', flag: '🇺🇦' },
    { code: '+375', country: 'belarus', flag: '🇧🇾' },
    { code: '+7', country: 'kazakhstan', flag: '🇰🇿' },
    { code: '+1', country: 'usa', flag: '🇺🇸' },
    { code: '+44', country: 'uk', flag: '🇬🇧' },
    { code: '+33', country: 'france', flag: '🇫🇷' },
    { code: '+39', country: 'italy', flag: '🇮🇹' },
    { code: '+34', country: 'spain', flag: '🇪🇸' },
    { code: '+48', country: 'poland', flag: '🇵🇱' },
    { code: '+420', country: 'czech', flag: '🇨🇿' },
    { code: '+43', country: 'austria', flag: '🇦🇹' },
    { code: '+41', country: 'switzerland', flag: '🇨🇭' },
    { code: '+31', country: 'netherlands', flag: '🇳🇱' },
    { code: '+32', country: 'belgium', flag: '🇧🇪' }
  ];

  const handleCountryCodeChange = (e) => {
    onChange({
      target: {
        name: 'countryCode',
        value: e.target.value
      }
    });
  };

  const handlePhoneChange = (e) => {
    onChange({
      target: {
        name: 'phone',
        value: e.target.value
      }
    });
  };

  return (
    <div className={`flex gap-2 ${className}`}>
      <select
        name="countryCode"
        value={value.countryCode || '+49'}
        onChange={handleCountryCodeChange}
        className="px-3 py-2 sm:py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all text-sm sm:text-base bg-white"
      >
        {countryCodes.map((country, index) => (
          <option key={`${country.code}-${country.country}-${index}`} value={country.code}>
            {country.flag} {country.code}
          </option>
        ))}
      </select>
      <input
        type="tel"
        name="phone"
        value={value.phone || ''}
        onChange={handlePhoneChange}
        className="flex-1 px-3 sm:px-4 py-2 sm:py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all text-sm sm:text-base"
        placeholder={placeholder || t('contact.form.phone_placeholder')}
      />
    </div>
  );
}
